"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrant_o = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.hydrant_o = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADr8AAA6/ATgFUyQAAAA+SURBVDhPY2RQ+/+fgWwA1AwEDKRikD4mqBFkAbCz/98E0iCOOgNBLyCrpcjmUc0kgoHTPMDJE8omETAwAABkWGLGmKiZxgAAAABJRU5ErkJggg==",
    iconSize: [15, 15],
});
